export default "__VITE_ASSET__D623g3EV__"